import React from 'react';
import { Box, CopyClipboard } from '@wix/design-system';
import { CardLayout } from '../../CommonWidgets/shared/CardLayout/CardLayout';
import { WithMarkdown } from '../../CommonWidgets/shared/WithMarkdown/WithMarkdown';
import { WithDisabledControl } from '../../..';
import { WidgetButton } from '../../CommonWidgets/shared/WidgetButton/WidgetButton';
import { useDisabledWidget } from '../../../shared/disabled-widget/useDisabledWidget';
import { WidgetLayout } from '../../CommonWidgets/shared/WidgetLayout/WidgetLayout';
export const CopyTextWidget = _ref => {
  let {
    data,
    context,
    config
  } = _ref;
  const {
    areControlsDisabled,
    enableControls
  } = useDisabledWidget(config);
  return /*#__PURE__*/React.createElement(WidgetLayout, {
    text: data.text,
    context: context,
    disabled: areControlsDisabled,
    onEnableControls: enableControls
  }, /*#__PURE__*/React.createElement(CardLayout, {
    borderless: true
  }, /*#__PURE__*/React.createElement(Box, {
    align: "space-between",
    verticalAlign: "middle",
    gap: "SP1"
  }, /*#__PURE__*/React.createElement(WithDisabledControl, {
    isDisabled: areControlsDisabled,
    onEnable: enableControls,
    t: context.t
  }, /*#__PURE__*/React.createElement(CopyClipboard, {
    value: data.text,
    resetTimeout: 2000
  }, _ref2 => {
    let {
      copyToClipboard,
      isCopied
    } = _ref2;
    return /*#__PURE__*/React.createElement(WidgetButton, {
      onClick: () => {
        copyToClipboard();
      },
      priority: "secondary",
      icon: {
        place: 'prefix',
        name: isCopied ? 'Check' : 'DuplicateSmall'
      },
      disabled: areControlsDisabled,
      context: context
    }, isCopied ? 'Copied' : 'Copy');
  }))), data.text && /*#__PURE__*/React.createElement(WithMarkdown, null, data.text)));
};
export const COPY_TEXT_WIDGET = 'COPY_TEXT_WIDGET';
//# sourceMappingURL=copyTextWidget.js.map